import axios from '../api' // 倒入 api
export const tools = {
  // 诚信/失信列表--我的
  selectCxCommendList: data => {
    return axios({
      url: '/huizb-app/creditPlatform/selectCxCommendList',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  // 诚信/失信列表
  selectOrgCxCommendList: data => {
    return axios({
      url: '/huizb-app/appOrg/selectOrgCxCommendList',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  // 诚信/失信删除
  deleteCxCommend: data => {
    return axios({
      url: '/huizb-app/creditPlatform/deleteCxCommend',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  // 诚信/失信详情--我的
  selectCxCommendDetail: data => {
    return axios({
      url: '/huizb-app/creditPlatform/selectCxCommendDetail',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 诚信/失信详情
  selectOrgCxCommendInfo: data => {
    return axios({
      url: '/huizb-app/appOrg/selectOrgCxCommendInfo',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 搜索项目
  getTenderDetailInfoByKeyword: data => {
    return axios({
      url: '/coi/bid/tender/v1/getTenderDetailInfoByKeyword',
      method: 'post',
      base: 'CORE',
      data
    })
  },
  // 诚信/失信新增
  submitCommend: data => {
    return axios({
      url: '/huizb-app/creditPlatform/submitCommend',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 诚信/失信修改
  updateCxCommendInfo: data => {
    return axios({
      url: '/huizb-app/creditPlatform/updateCxCommendInfo',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 行业自律公约签署列表
  getAssOrgRelation: data => {
    return axios({
      url: '/huizb-app/appOrg/getAssOrgRelation',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  // 行业自律公约签署新增
  submitOrder: data => {
    return axios({
      url: '/huizb-app/appOrder/submitOrder',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 行业自律公约协会列表
  getUnionList: data => {
    return axios({
      url: '/huizb-app/creditPlatform/getUnionList',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  // 行业自律公约协会详情
  getUnionInfo: data => {
    return axios({
      url: '/huizb-app/appUnion/getUnionInfo',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  // 失真质疑列表
  selectCxQuestionList: data => {
    return axios({
      url: '/huizb-app/creditPlatform/selectCxQuestionList',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  // 失真质疑删除
  deleteCxQuestion: data => {
    return axios({
      url: '/huizb-app/creditPlatform/deleteCxQuestion',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 失真质疑查看
  selectCxQuestionDetail: data => {
    return axios({
      url: '/huizb-app/creditPlatform/selectCxQuestionDetail',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 失真质疑新增
  submitQuestion: data => {
    return axios({
      url: '/huizb-app/creditPlatform/submitQuestion',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 失真质疑修改
  updateCxQuestionInfo: data => {
    return axios({
      url: '/huizb-app/creditPlatform/updateCxQuestionInfo',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 失真质疑 
  getBaseContentsByNewCode: data => {
    return axios({
      url: '/huizb-app/orgContent/getBaseContentsByNewCode',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  // 业绩补充列表
  selectCxOrgAddAchievementList: data => {
    return axios({
      url: '/huizb-app/creditPlatform/selectCxOrgAddAchievementList',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  // 业绩补充删除
  deleteCxOrgAddAchievement: data => {
    return axios({
      url: '/huizb-app/creditPlatform/deleteCxOrgAddAchievement',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 业绩补充查看
  selectCxOrgAddAchievementDetail: data => {
    return axios({
      url: '/huizb-app/creditPlatform/selectCxOrgAddAchievementDetail',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 业绩补充新增
  submitAchievement: data => {
    return axios({
      url: '/huizb-app/creditPlatform/submitAchievement',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 业绩补充修改
  updateCxOrgAddAchievementInfo: data => {
    return axios({
      url: '/huizb-app/creditPlatform/updateCxOrgAddAchievementInfo',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },

}
export default tools